import { render, staticRenderFns } from "./ProcessosForm.vue?vue&type=template&id=58d483d8&"
import script from "./ProcessosForm.vue?vue&type=script&lang=js&"
export * from "./ProcessosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports